"use client";

// Tiny mount-only client component, same pattern as SiteVisitTracker /
// DiagnosticsAutoFlushClient. Installs the heartbeat drift detector
// (lib/freeze-watchdog.ts) once for the lifetime of the client-side React
// tree. Renders nothing.

import { useEffect } from "react";
import { installFreezeWatchdog } from "../../lib/freeze-watchdog";

export default function FreezeWatchdogClient() {
  useEffect(() => {
    installFreezeWatchdog();
  }, []);
  return null;
}
